<template>
  <Col cols="12">
    <span class="text-paragraph-2" v-text="title"/>
    <slot/>
  </Col>
</template>

<script>
import { Col } from '@locaweb/design-system-vue'

export default {
  name: 'ListItem',
  components: {
    Col
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
